/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-tag-spacing */
/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from 'react';
import Head from 'next/head';

const getConfig = require('next/config').default;
const UAParser = require('ua-parser-js');

const parser = new UAParser();

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};
const version = publicRuntimeConfig.VERSION;

const HeadScripts = () => {
  const [bluekaiConfig, setBluekaiConfig] = useState({ action: 'navigate', appversion: version });

  useEffect(() => {
    const broswerInf = parser.getResult();
    const d = new Date();
    const date = new Date(d.toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));
    const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    if (broswerInf?.ua.length > 0) {
      setBluekaiConfig({
        browser: broswerInf.browser.name,
        browserver: broswerInf.browser.version,
        device_model: broswerInf.device.model,
        device_type: broswerInf.device.type,
        device_vendor: broswerInf.device.vendor,
        os: broswerInf.os.name,
        os_version: broswerInf.os.version,
        screenres: `${screen.width}x${screen.height}`,
        hour: date.getHours(),
        weekday: weekdays[date.getDay()]
      });
    }
  }, []);

  return (
    <Head>
      <script type="application/json" id="mc-bluekai-config" dangerouslySetInnerHTML={{ __html: JSON.stringify(bluekaiConfig) }} />
    </Head>
  );
};

export default HeadScripts;
